export default class RfpHelperService {
  isSubmitted(rfp) {
    let status = rfp.responseStatus;

    return (
      status === 'OfferSubmitted' ||
      status === 'OfferAccepted' ||
      status === 'OfferRejected'
    );
  }

  isExpired(rfp) {
    return rfp.responseStatus === 'OfferExpired';
  }

  isSIO(rfp) {
    return rfp.type === 'SIO';
  }
}
